export default __webpack_public_path__ + "static/media/calendar_v_routine.474a8b45.svg";